import { $$, on } from './util';

export function open(target: HTMLDialogElement | string): void {
  const d = (typeof target === 'string' ? document.querySelector(target) : target) as HTMLDialogElement | null;
  if (!d) return;
  if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
}

export function close(target: HTMLDialogElement | string): void {
  const d = (typeof target === 'string' ? document.querySelector(target) : target) as HTMLDialogElement | null;
  if (!d) return;
  if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
}

export function init(root: ParentNode = document): void {
  for (const t of $$<HTMLElement>('[data-bf-toggle="drawer"]', root)) {
    const sel = t.getAttribute('data-bf-target');
    if (!sel) continue;
    on(t, 'click', (e) => { e.preventDefault(); open(sel); });
  }
  for (const c of $$<HTMLElement>('[data-bf-dismiss="drawer"]', root)) {
    on(c, 'click', () => {
      const d = c.closest('dialog') as HTMLDialogElement | null;
      if (d) close(d);
    });
  }
}
